module.exports = __webpack_public_path__ + "img/icon.fc12c195.svg";